import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=c70c6d1c&scoped=true&"
import script from "./doc.vue?vue&type=script&lang=js&"
export * from "./doc.vue?vue&type=script&lang=js&"
import style0 from "./doc.vue?vue&type=style&index=0&id=c70c6d1c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70c6d1c",
  null
  
)

export default component.exports